import type { CheckoutProps } from "js/react/views/Billing/Checkout";
import { t } from "js/i18n";

export interface AiOnboardingUserState {
    started: boolean;
    useCaseSelection: AiOnboardingUseCases;
    generatedPresentationId: string;
    copyDeckPresentationId: string;
    checkoutProps: CheckoutProps;
    completed: boolean;
}

export enum AiOnboardingSteps {
    USE_CASE_SELECTION = "useCaseSelection",
    PRESENTATION_GENERATION = "presentationGeneration",
    CHECKOUT_OVERLAY = "checkoutOverlay",
    TRIAL_CONFIRMATION = "trialConfirmation",
}

export enum AiOnboardingUseCases {
    SALES_PITCH = "salesPitch",
    INTERNAL_UPDATE = "internalUpdate",
    CLIENT_DELIVERABLE = "clientDeliverable",
    FUNDRAISING_DECK = "fundraisingDeck",
    PERSONAL_PROJECTS = "personalProjects",
    CONFERENCE_EVENT = "conferenceEvent",
}

interface AiOnboardingUseCaseOption {
    label: string;
    description: string;
    iconPath: string;
    prompt: string;
    presentationId: string;
}

export const AiOnboardingUseCaseOptions: Record<AiOnboardingUseCases, AiOnboardingUseCaseOption> = {
    [AiOnboardingUseCases.SALES_PITCH]: {
        label: t("Sales"),
        description: t("Prospecting decks, demos & proposals"),
        iconPath: "/images/ai-onboarding/use-case-options/sales-pitch.svg",
        prompt: t("Create a persuasive sales pitch for our new CRM tool"),
        presentationId: "-OZjJ85FYDyoBCNNBhpP"
    },
    [AiOnboardingUseCases.INTERNAL_UPDATE]: {
        label: t("Team"),
        description: t("Team meetings & progress reports"),
        iconPath: "/images/ai-onboarding/use-case-options/internal-update.svg",
        prompt: t("Summarize this quarter’s KPIs for the marketing team"),
        presentationId: "-OZoFtnkR-tD2H9MTtWg"
    },
    [AiOnboardingUseCases.CLIENT_DELIVERABLE]: {
        label: t("Client"),
        description: t("Proposals, reports & work shared"),
        iconPath: "/images/ai-onboarding/use-case-options/client-deliverable.svg",
        prompt: t("Build a branded deck to present campaign results"),
        presentationId: "-OZqbg_FW5ciiVuF8HaH"
    },
    [AiOnboardingUseCases.FUNDRAISING_DECK]: {
        label: t("Fundraising"),
        description: t("Investor pitches & startup overviews"),
        iconPath: "/images/ai-onboarding/use-case-options/fundraising-deck.svg",
        prompt: t("Make a 10-slide investor pitch for a fintech startup"),
        presentationId: "-OZpjA6ioOsIb6dipfO7"
    },
    [AiOnboardingUseCases.CONFERENCE_EVENT]: {
        label: t("Events"),
        description: t("Speaker slides, panels & keynotes"),
        iconPath: "/images/ai-onboarding/use-case-options/conference-event.svg",
        prompt: t("Create a talk for an industry event on AI in retail"),
        presentationId: "-OZpKHWtWENxfCM0AuZL"
    }, [AiOnboardingUseCases.PERSONAL_PROJECTS]: {
        label: t("Personal"),
        description: t("Portfolios, freelance work & ideas"),
        iconPath: "/images/ai-onboarding/use-case-options/personal-project.svg",
        prompt: t("Draft a slide deck to plan my upcoming wedding"),
        presentationId: "-OZqjqq98F3MWJ-xPPFS"
    },
};
